<template>
	<div class="threads">
		<div>
			<div v-if="!firstFetchDone" class="text-center" style="margin-top: 30px;">
				<spinner :inline="true"></spinner>
				<p>Loading messages</p>
			</div>
			<div v-if="showMessageSearchResults">
				<h3>Search for '{{ searchedTerms }}' <small>({{mutatedSearchResults.length}} matches)</small>:</h3>

				<ul class="search-results list-group">
					<li class="list-group-item-action list-group-item" v-for="result in mutatedSearchResults" style="cursor: pointer;" v-on:click="selectThread({slug: result.thread_slug})">

						<h5>{{result.subject}}</h5>
					
						<div class="d-flex flex-row justify-content-between flex-wrap">
							<div>{{result.shortMessage}}</div>
							<div class="text-muted">{{formatDateTimeToLocal(result.message_created_at,'full-date-time')}}</div>
						</div>						

					</li>
				</ul>
			</div>
			<div v-else class="threads-container">

				<div v-if="$store.threadsWithNewMessages.length > 0" class="unread-threads" :style="{'marginTop':isPanel ? '30px' : '0'}">
					<h4 v-if="!isPanel">Unread ({{unreadThreads.length}})</h4>

					<message-thread-card 
					 	v-for="thread in mutateThreads(unreadThreads)" 
						:key="thread.id"
						:thread="thread"
						:image-url="thread.imageUrl"
						v-on:click="selectThread(thread)">
					</message-thread-card>

				</div>

				<div class="normal-threads" v-on:scroll="scrollThreads">

					<div class="">

						<field style="margin-bottom: 10px" 
							v-model="filters" 
							v-on:change="filterThreads" 
							:params="{type:'btn-group',buttons:filterButtons, tabStyling:true}"
							:disable-null="true">
						</field>

						<div class="text-center" v-if="checkingInBackground">
							<i class="fa fa-spin fa-spinner"></i>
							Checking for new threads...
						</div>

					</div>

					<div v-if="showNoMessages && firstFetchDone" class="text-center" style="font-size: 18pt;margin-top: 50px;">
						<p>No messages <i class="fa fa-frown"></i></p>
						<button v-on:click="newThread" class="btn btn-link btn-lg">Send one now!</button>
					</div>

					<template v-else>
						<div :class="{'custom-side-margins':sideMargins}">
							<message-thread-card 
								v-for="thread in mutateThreads(threadList)" 
								:key="thread.id"
								:thread="thread"
								:image-url="thread.imageUrl"
								:style="{marginLeft: sideMargins, marginRight: sideMargins}"
								v-on:click="selectThread(thread)">
							</message-thread-card>
						</div>

						<div v-if="loading" class="text-center mt-2">
							<i class="fa fa-spin fa-spinner"></i>
							Loading older threads...
						</div>

						<div class="text-center" v-if="!showingSearchResults && !loading">
							<button class="btn btn-sm btn-light" v-on:click.prevent="loadMoreThreads">
								<i class="fa fa-chevron-down"></i>
								More...
							</button>
						</div>
					</template>
				</div>

			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import JobThreadList from "../../layout_fragments/messages/JobThreadList"
import MessageThreadCard from "../../layout_fragments/messages/MessageThreadCard"
import Field from "../Field"
import Widget from "@/components/Widget"
import Spinner from "@/components/Spinner"

import MessageMixins from "@/mixins/MessageMixins.js"

export default {
	name: "MessageThreadList",
	components: {
		JobThreadList,
		MessageThreadCard,
		Field,
		Spinner,
		Widget
	},
	mixins: [MessageMixins],
	props:["sideMargins","isPanel","jobId","serviceId","storeThreadsLocally"],
	data() {
		return {
			page: 1,
			threadList: [],
			threadsWithNewMessages: [],
			filters: 'active',
			unreadThreads: [],
			threadInclude: [
				{model:"User",fields:["id","slug","first_name","last_name","image_id","last_active"]},
				{model:"Job",fields:["id","slug","job_num","job_name"]},
				{model:"Service",fields:["id","slug","job_num","job_name"]},
				/*{
					model:"Message",
					page:1,
					orders:[["created_at","DESC"]],
					wait:false
				}*/
			],
			jobInclude: [
				{
					model: "MessageThread", 
					include:[
						{model:"User",fields:["id","slug","first_name","last_name","image_id","last_active"]}
					],
					page: 1
				},
				{model:"User",fields:["first_name","last_name","image_id","last_active"]}
			],
			jobFilters: [
				["MessageThread.id !=",0],
				["archived",0]
			],
			jobFields: ["job_num","job_name"],
			threadProfileImages: [],
			jobThreadProfileImages: [],
			unreadThreadProfileImages: [],
			firstFetchDone: false,
			jobServicePage: 1,
			showingSearchResults: false,
			loading: false,
			checkingInBackground: false,
			searchedTerms: "",
			searchResults: [],
			showMessageSearchResults: false,
			threadsFetching: false
		}
	},
	watch: {
		serviceId() {
			this.fetchData(true)
		},
		jobId() {
			this.fetchData(true)
		},
		'$store.threadsWithNewMessages'() {
			let vm = this

			this.$store.checkingMessages = true;

			if (this.unreadThreads.length == 0 && this.$store.threadsWithNewMessages.length > 0) {
				let unreadParams = {
					filters: [
						["id",this.$store.threadsWithNewMessages]
					],
					include: vm.threadInclude
				}

				this.getJSON("MessageThread/get",unreadParams).then(response => {
					if (response.success)
						vm.unreadThreads = vm.mutateThreads(response.data)

					vm.$store.checkingMessages = false;
				})
			}
		},
		'$store.threadList'() {
			if (!this.storeThreadsLocally)
				this.threadList = this.$store.threadList
		}
	},
	computed: {
		mutatedSearchResults() {
			let vm = this

			return this.searchResults.map(result => {
				result.shortMessage = result.message.substr(0,100)

				if (result.shortMessage.length < result.message.length)
					result.shortMessage += "..."

				return result
			})
		},
		filterButtons() {
			if (this.isPanel || window.innerWidth < 730) {
				return [
					{text:'All',value:'all'},
					{text:'Active',value:'active'},
					{text:'Archived',value:'archived'}
				]
			}
			else {
				let tabs = [
					{text:'All',value:'all'},
					{text:'Active',value:'active'},
					{text:'Direct Messages',value:'messages'},
					{text:'Record Comments',value:'comment'},
					{text:'Archived',value:'archived'}
				]

				if (!this.jobId && !this.serviceId)
					tabs.splice(3,0,
					{text:'Project/Service Related',value:'job'})

				return tabs
			}
		},
		showNoMessages() {
			let showNoMessages = false;

			if (!this.threadList || this.threadList.length == 0)
				return true
			else
				return false		
		},
	},
	methods: {
		setThreadList(threads) {
			if (!this.storeThreadsLocally) 
				this.$store.threadList = threads
		
			this.threadList = threads
		},
		appendThreadList(newThreads) {
			if (!this.storeThreadsLocally) 
				this.$store.threadList = [
					...this.$store.threadList,
					...newThreads
				]
		
			this.threadList = [
				...this.threadList,
				...newThreads
			]
		},
		scrollThreads() {

			let d = document.documentElement;
			let offset = d.scrollTop + window.innerHeight;
			let height = d.offsetHeight;

			if (offset >= height) {
				this.loadMoreThreads()
			}
		},
		mutateThreads(threadList) {
			let vm = this

			let threads = [] 
			try {
				threads = JSON.parse(JSON.stringify(threadList))
			}
			catch (e) {}

			if (this.jobId > 0 || this.serviceId > 0) 
				threads = threads.filter(thread => this.jobId == thread.job_id || this.serviceId == thread.service_id)

			return threads.map(thread => {

				if ("Service" in thread && thread.Service) 
					thread.subject = thread.Service.job_num+": "+thread.subject
				
				else if ("Job" in thread && thread.Job) 
					thread.subject = thread.Job.job_num+": "+thread.subject

				return vm.attachImageToThread(thread,vm.threadProfileImages)				
			})
		},
		loadMoreThreads() {
			this.page++
			this.fetchThreads()
		},
		newThread() {
			this.$bus.$emit("newThread")
		},
		selectThread(thread) {
			if (!this.isPanel)
				this.$router.push("/message/"+thread.slug).catch(err => {})
			else
				this.$emit("selectThread",thread)
		},
		searchMessages(searchTerms) {
			this.searchedTerms = searchTerms

			let vm = this

			this.spinner(true)

			this.getJSON("MessageThread/search",{terms:searchTerms}).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.searchResults = response.data
				}
			})
			this.showMessageSearchResults = true
		},
		compiledThreadFilters(searchTerms) {
			let vm = this

			if (!searchTerms) {
					//params.lastOffset = vm.lastOffset

				let filters = []

				if (this.serviceId)
					filters = [["service_id",this.serviceId]]

				if (this.jobId)
					filters = [["job_id",this.jobId]]

				if (vm.filters == 'job') {
					filters = [
						["service_id >",0],
						["job_id >",0,"or"]
					]
				}
				else if (vm.filters == 'active') {
					filters.push(["archived",0])
					filters.push(["is_comment_thread",0])
				}
				else if (vm.filters == 'messages') {
					filters.push(["is_comment_thread",0])
					filters.push(["service_id <",1])
					filters.push(["job_id <",1])
				}
				else if (vm.filters == 'comment') {
					filters.push(["is_comment_thread",1])
				}
				else if (vm.filters == 'archived') {
					filters.push(["archived",1])
					filters.push(["is_comment_thread",0])
				}

				return filters
			}
			else {
				return [
					["subject",searchTerms,"like"]
				]
			}
		},
		fetchThreads(searchTerms,init) {
			let vm = this

			if (this.loading) {
				//this.alertInfo("Already fetching, please wait...",true)
			}
			else {
				this.loading = true

				let params = {
					include: vm.threadInclude,
					filters: vm.compiledThreadFilters(searchTerms),
					onlyMemberThreads: true,
					page: this.page
				}

				let promises = [
					this.getJSON("MessageThread/get",params)
				]

				Promise.all(promises).then(responses => {

					vm.loading = false

					if (responses[0].success) {

						//vm.lastOffset = responses[0].lastOffset

						if (searchTerms) {
							vm.setThreadList(responses[0].data)

							vm.showingSearchResults = true
						}
						else {
							vm.showingSearchResults = false

							if (init) 
								vm.setThreadList(responses[0].data)

							else {
								vm.appendThreadList(responses[0].data)
							}
						}
					}
				})
			}
		},
		filterThreads() {
			this.fetchThreads(false,true)
		},
		fetchData(spinner) {

			if (spinner)
				this.loading = true
			else
				this.checkingInBackground = true

			let vm = this

			/* 
			* Threads will be fetched first with no includes for a rapid response, and then fetched
			* again WITH includes to fill out the Member list, and job data
			*/

			let unreadParams = {
				filters: [
					["id",this.$store.threadsWithNewMessages]
				],
				onlyMemberThreads: true
				//include: vm.threadInclude
			}

			let threadParams = {
				//include: vm.threadInclude,
				onlyMemberThreads: true,
				page: 1,
				filters: vm.compiledThreadFilters(false)
			}

			if (this.serviceId) {
				threadParams.filters = [["service_id",this.serviceId]]
				unreadParams.filters.push(["service_id",this.serviceId])
			}

			if (this.jobId) {
				threadParams.filters = [["job_id",this.jobId]]
				unreadParams.filters.push(["job_id",this.jobId])
			}

			threadParams.include = vm.threadInclude
			unreadParams.include = vm.threadInclude

			let promises = [
				this.getJSON("MessageThread/get",threadParams)
			]

			if (this.$store.threadsWithNewMessages.length > 0) 
				promises.push(this.getJSON("MessageThread/get",unreadParams))
			

			Promise.all(promises).then(responses => {

				if (spinner)
					vm.loading = false

				vm.firstFetchDone = true

				let newList = []
				if (responses[0].success)
					newList = responses[0].data

				let existingList = JSON.parse(JSON.stringify(vm.threadList))

				if (responses[0].success) {
					vm.setThreadList(responses[0].data)

					localStorage.threadList = JSON.stringify(vm.threadList)

					vm.fetchProfileImages(vm.threadList).then(images => {
						vm.threadProfileImages = vm.threadProfileImages.concat(images)
					})
				}

				//merge new threadlist with existing
				vm.threadList.forEach(thread => {
					let oldThread = existingList.find(existingThread => existingThread.id == thread.id)

					if (oldThread && "Members" in oldThread)
						thread.Members = oldThread.Members
				})

				vm.checkingInBackground = false

				//set unread thread list
				if (responses.length == 2 && responses[1].success) {
					vm.unreadThreads = responses[1].data
					vm.fetchProfileImages(vm.unreadThreads).then(images => {
						vm.threadProfileImages = vm.threadProfileImages.concat(images)
					})
				}
			})
		},
	},
	created() {
		let vm = this

		if (!vm.storeThreadsLocally)
			this.threadList = this.$store.threadList

		//pull threads from localstorage if they exist
		if ("threadList" in localStorage) {
			try {
				let parsed = JSON.parse(localStorage.threadList)
				vm.setThreadList(parsed)
				this.firstFetchDone = true
			}
			catch (e) {}
		}

		if (!vm.storeThreadsLocally && vm.$store.threadList.length > 0) 
			vm.firstFetchDone = true
		else if (vm.storeThreadsLocally && vm.threadList.length > 0)
			vm.firstFetchDone = true

		this.fetchData(!vm.firstFetchDone)

		this.$bus.$on("reloadMessages",() => {
			vm.$store.activeThread = null
			vm.page = 1

			vm.setThreadList([])

			vm.fetchData()
		})

		this.$bus.$on("searchThreads",(params) => {
			if (params.includeMessages)
				vm.searchMessages(params.terms)
			else
				vm.fetchThreads(params.terms)
		})

		this.$bus.$on("clearSearch",() => {
			vm.setThreadList([])
			vm.showMessageSearchResults = false
			vm.searchTerms = []

			vm.fetchData(true)
		})
		
		this.$bus.$on("newThreadCreated",() => {
			vm.fetchThreads(false,true)
		})

		if (!this.isPanel)
			this.$emit("closePanel")

		//window.addEventListener('scroll', this.scrollThreads);

		//this.scrollThreads()
	},
	destroyed() {
		this.$store.currentMessagePollingInterval = this.messageSettings.slowPolling

		//window.removeEventListener('scroll', this.scrollThreads);
	}
}
</script>

<style type="text/css">
	.custom-side-margins .card {
		border-left: none;
	}

	.threads::-webkit-scrollbar {
		width: 0px; /* remove scrollbar space */
		background: transparent; 
	}
</style>